import { render, staticRenderFns } from "./TriviaTitle.vue?vue&type=template&id=40fccda3&scoped=true&"
import script from "./TriviaTitle.vue?vue&type=script&lang=js&"
export * from "./TriviaTitle.vue?vue&type=script&lang=js&"
import style0 from "./TriviaTitle.vue?vue&type=style&index=0&id=40fccda3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fccda3",
  null
  
)

export default component.exports